import { useState } from "react";
import { Badge, Col, Container, Pagination, Row } from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import Error from "./Error";
import MDEditor from "@uiw/react-md-editor";
import ArticlePreview from "./ArticlePreview";

import './Article.css';

const metadata = require('../Article/.metadata.json');

function Article() {

    const navigate = useNavigate();
    let { id } = useParams();
    const [ searchParams ] = useSearchParams();
    const [ articleContent, setArticleContent ] = useState('');
    const all = Object.keys(metadata);
    
    var pageSlice: string[]|undefined, allPages: number = 1;

    // Get page and tag URL params
    let page: number = Number(searchParams.get('page'));
    let tag: string|null = searchParams.get('tag');

    function pagination(page: number) {
        navigate({search: `?${(searchParams.get('tag') === null ? 'asd&' : 'tag=' + searchParams.get('tag') + '&')}page=${page}`});
        window.scroll({top: 0, behavior: 'smooth'});
    }

    if(id === undefined && tag === null && page === 0) window.location.href = '/article?page=1'; // Redirect to page 1 if article id or page number is not specified.
    if(tag !== null && page === 0){
        window.location.href = window.location.href + '&page=1';
        return (<></>);
    }

    if(id === undefined || tag !== null){
        if(tag !== null){
            pageSlice = all.filter(id => {
                try {
                    return metadata[id].tag.includes(tag);
                }
                catch (error) {}
                return 0;
            });
            allPages = Math.ceil(pageSlice.length / 10);
            pageSlice = pageSlice.slice((page - 1) * 10, page * 10);
    
            if(pageSlice.length === 0) return (
                <>
                    <Container className='text-center'>
                        <h1>Article not found.</h1>
                        <p>
                            There is no article with tag "{tag}".
                        </p>
                    </Container>
                </>
            );
        }
        else if(id === undefined){
            pageSlice = all.slice((page - 1) * 10, page * 10);
            allPages = Math.ceil(all.length / 10); // Get all pages

            if(pageSlice.length === 0) window.location.href = '/articles?page=1'; // Redirect to page 1 if current page is greater than all pages.
        }

        if(pageSlice === undefined) return <></>; // Check if pageSlice is undefined.

        return (
            <>
                <Container>
                    <Row>
                        <Col md={1}></Col>
                        <Col md={10}>
                            <ArticlePreview pageSlice={pageSlice} metadata={metadata} />
                        </Col>
                        <Col md={1}></Col>
                    </Row>

                    <div className='d-flex justify-content-center'>               
                        <Pagination>
                            <Pagination.Prev onClick={(() => pagination(page > 1 ? page - 1 : 1))} />
                            {
                                page === 1 ? <></> :
                                <>
                                    <Pagination.Item onClick={(() => pagination(1))}>{1}</Pagination.Item>
                                    <Pagination.Ellipsis />
                                </>
                            }
                            <Pagination.Item active>{page}</Pagination.Item>
                            {
                                page === allPages ? <></> :
                                <>
                                    <Pagination.Ellipsis />
                                    <Pagination.Item onClick={(() => pagination(allPages))}>{allPages}</Pagination.Item>
                                </>
                            }
                            <Pagination.Next onClick={(() => pagination(page < allPages ? page + 1 : allPages))} />
                        </Pagination>
                    </div>
                </Container>
            </>
        );
    }

    try {
        // Show article
        var article = metadata[id];
        fetch('https://91d906h4.github.io/articles/' + id + '.md')
        // fetch('http://localhost:3000/articles/' + id + '.md')
        .then(raw => raw.text())
        .then(content => setArticleContent(content));
    
        return (
            <>
                <Container>
                    <h1 className='article-article-title'>{article.title}</h1>
                    <p>
                        {article.time} by <span className='text-primary'>{article.author}</span><br />
                        Tag:
                            {
                                article.tag.map((tag: string) => {
                                    return <span key={Math.random()}> <a href={'/article?tag=' + encodeURIComponent(tag)}><Badge bg="secondary">{tag}</Badge></a></span>;
                                })
                            }
                    </p>
                    <p>{article.description}</p>
                    <hr />
                    <MDEditor.Markdown source={articleContent} />
                </Container>
            </>
        );
    }
    catch (error) { return <Error code={404} />; }
}

export default Article;